module.exports = __webpack_public_path__ + "img/battery-red.11e940f2.svg";